import { IViewModel } from '../../interfaces/view-model.interface';

export class Undo implements IViewModel {
    // Constants.
    public static readonly undoStatus_Created = "Created";
    public static readonly ndoStatus_Undone = "Undone";
    //public static readonly undoStatus_Redone = "Redone";

    public static readonly appArea_FolderPermission = "FolderPermission";

    // Properties.
    public id: number;

    public dataCollectionId: number;

    public undoType: string;

    public undoStatus: string;

    public applicationArea: string; // If undo logic is applied to new areas within vNext, this could distinguish some types of undo records from others.
}
